import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { EntryPoints } from './components/entry-points';
export var CnEntryPoints = withI18n(EntryPoints, { locale: locale });
